import { getDefaultSearchFilters } from '../../consts/searchFilters';
import {
  SearchFilters,
  GetOrderAssistInput,
  SearchOptionsInput,
  OrderAssistFormDataWithOptions,
  AppPatient,
} from '../../types';

interface CalculateSearchParamsProps {
  searchFormData: OrderAssistFormDataWithOptions;
  patient: AppPatient;
  token: string | undefined;
  isCostAvailable: boolean;
  searchFilters?: SearchFilters;
  supportDistance: boolean;
  isWiderDistanceAvailable: boolean;
  defaultDistanceFilter: number;
  useGeoCoordinatesOnly: boolean;
}

interface SearchParams {
  input: GetOrderAssistInput;
  options: SearchOptionsInput;
}

export const calculateSearchParams = ({
  searchFormData,
  patient,
  token,
  isCostAvailable,
  searchFilters,
  supportDistance,
  isWiderDistanceAvailable,
  defaultDistanceFilter,
}: CalculateSearchParamsProps): SearchParams => {
  const {
    firstName,
    lastName,
    facilityName,
    npi,
    specialty,
    cpt,
    icd,
    placeOfService,
    address,
    insurer,
    insurancePlan,
    network,
  } = searchFormData;
  const defaultFilters = getDefaultSearchFilters({
    supportWiderDistance: isWiderDistanceAvailable,
    defaultDistanceFilter,
    supportDistance,
  });

  const advancedSearch = { lastName, firstName, npi, facilityName };

  let referredToPlaceOfService;
  if (placeOfService) {
    referredToPlaceOfService = { code: placeOfService, display: placeOfService };
  }

  const input: GetOrderAssistInput = {
    anonymizedPatient: token,
    memberToken: undefined,
    searchInput: {
      vimSpecialtyId: specialty?.vimSpecialtyId,
      cpt: cpt?.map((element) => element.value),
      icd: icd?.map((element) => element.value),
      advancedSearch,
      referredToPlaceOfService,
      address: {
        ...(address || {}),
        zipCode: address?.zipCode ?? patient.demographics.address?.zipCode ?? '',
      },
      insurer,
      insurancePlan,
      network: network ? network.value : undefined,
    },
  };

  const { options: searchOptions } = searchFormData;
  const { distance, language } = searchFilters || {};
  const options: SearchOptionsInput = {
    radius: distance || defaultFilters.distance,
    languageCode: language || defaultFilters.language,
    ...(searchOptions?.pagination ? { pagination: searchOptions?.pagination } : {}),
    forceCost: isCostAvailable,
  };

  return { input, options };
};
